import React, { Component } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import '../../config'
import Menu from '../menu/Menu';
import './ListaFolha.css';
import AssinaHolerite from '../AssinaHolerite/AssinaHolerite';
import ExportPDF from '../ExportPDF/ExportPDF';
import Cookies from 'universal-cookie';



export default class ListaFolha extends Component {

    state = {
        _Folha: [],
        ckCPF: '',
    }


    async componentDidMount() {
        const cookies = new Cookies();
        this.state.ckCPF = cookies.get('ckCPF')
        // console.log(this.state.ckCPF)
        const response = await api.get(`/datasnap/rest/tsm/RecFolha("${this.state.ckCPF}")`);
        this.setState({ _Folha: response.data.result[0] });
        // console.log(response.data.result[0]);
    }
    render() {
        return (
            <div className="principal">
                <div className="ListPed">
                    <Menu />
                    <p></p>
                    <h2>Ultimas Folhas de Pagto.</h2>
                    <table className="table table-hover table-striped table-dark align-middle">
                        <thead>
                            <tr>
                                {/* {"COMPETENCIA":"01/09/2020","DESCONTOS":"6239,82","PROVENTOS":"22702,61","TIPO_PROCES_DESC":"Folha Mensal ","ASS":"NÃO ASSINADO"}] */}
                                <th scope="col">Competência</th>
                                {/* <th scope="col">Tipo da Folha</th> */}
                                <th scope="col">Detalhes</th>
                                <th scope="col">Ass.</th>
                                <th scope="col">Imp.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state._Folha.map(Folha => (
                                <tr key={Folha.COMPETENCIA + Folha.TIPO_PROCES_DESC}>
                                    <td>{String(Folha.COMPETENCIA).substr(3, 7)}   {Folha.TIPO_PROCES_DESC} </td>
                                    {/* <td>{Folha.TIPO_PROCES_DESC}</td> */}
                                    <td><Link to={`/HOn/DetalheFolha/"${String(Folha.COMPETENCIA).substr(6, 4) +
                                        "-" + String(Folha.COMPETENCIA).substr(3, 2) +
                                        "-" + String(Folha.COMPETENCIA).substr(0, 2) +
                                        "-" + Folha.TIPO_PROCES_DESC 
                                        }"`}>Detalhes</Link></td>
                                    <td>
                                        {(Folha.ASS === 'ASSINADO') ? 
                                            <button className="btn btn-primary btn-sm" disabled={true}>
                                                SIM
                                            </button>
                                            : 
                                            <button className="btn btn-render btn-warning btn-sm" disabled={false} onClick={e => AssinaHolerite(Folha.TIPO_PROCES_DESC, Folha.COMPETENCIA)}>
                                                NÃO
                                            </button>
                                        }
                                    </td>
                                    <td>
                                        {(Folha.ASS === 'ASSINADO') ?
                                            <button className="btn btn-success btn-sm" disabled={false} onClick={e => ExportPDF(Folha.COMPETENCIA, Folha.TIPO_PROCES_DESC)}>
                                                PDF
                                            </button>
                                        :
                                            <button className="btn btn-success btn-sm" disabled={true} onClick={e => ExportPDF(Folha.COMPETENCIA, Folha.TIPO_PROCES_DESC)}>
                                                PDF
                                            </button>
                                        }
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}